// SingleCheckoutForm.jsx
import React, { useState } from 'react';
import { Button, Form, Row, Col, Container, Card, Alert } from 'react-bootstrap';
import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { useNavigate } from 'react-router-dom';
import axios from '../../backendClient';
import './singlecheckoutform.scss';
import FlatStyledCard from './FlatStyledCard';
// import { useSelector } from 'react-redux';

const SingleCheckoutForm = ({
  locationState,
  eventId,
  ticketId,
  ticketAmountCents,
  slug,
  demoMode = false,
  ticketLabel = 'Selected Ticket', 
}) => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  // const { currentUser } = useSelector(s => s.user || {});

  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [promoCode, setPromoCode] = useState('');

  const handleError = (err) => {
    setLoading(false);
    const msg =
      err?.message ||
      err?.response?.data?.error ||
      'Something went wrong. Please try again.';
    setErrorMessage(msg);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');

    // OPTIONAL login gate — commented out per your request
    // if (!currentUser) {
    //   navigate('/login', { replace: true, state: { from: locationState || window.location.pathname, eventId } });
    //   return;
    // }

    if (!stripe || !elements) return;

    // Require a ticket selection
    if (!ticketId) {
      setErrorMessage('Please select a ticket before paying.');
      return;
    }

    setLoading(true);

    // 1) Validate + collect wallet details
    const { error: submitError } = await elements.submit();
    if (submitError) { handleError(submitError); return; }

    // 2) Create a PaymentMethod from the Payment Element
    const { error, paymentMethod } = await stripe.createPaymentMethod({ elements });
    if (error) { handleError(error); return; }

    try {
      // 3) Ask backend to create + CONFIRM the one-time PaymentIntent
      // In demoMode (no backend), this will likely 404/500 — we catch and show a friendly message.
      const res = await axios.post('/api/payments/one-time/confirm', {
        eventId,                        // may be null in demo
        ticketId,
        paymentMethodId: paymentMethod.id,
        promoCode: promoCode || null,   // optional
      });

      if (res.data?.status === 'requires_action' && res.data.clientSecret) {
        const { error: actErr } = await stripe.handleNextAction({ clientSecret: res.data.clientSecret });
        if (actErr) { handleError(actErr); return; }

        const fin = await axios.post('/api/payments/one-time/finalize', {
          paymentIntentId: res.data.paymentIntentId,
        });

        if (fin.data?.ok && fin.data.status === 'paid') {
          navigate(`/single/${slug || ''}`, { state: { paid: true } });
        } else {
          setErrorMessage(`Payment status: ${fin.data?.status || 'unknown'}`);
        }
      } else if (res.data?.ok && res.data.status === 'paid') {
        navigate(`/single/${slug || ''}`, { state: { paid: true } });
      } else {
        setErrorMessage(res.data?.error || `Payment status: ${res.data?.status || 'unknown'}`);
      }
    } catch (e2) {
      // Friendly message when backend route isn't wired yet
      if (demoMode) {
        setErrorMessage(
          'Demo mode: backend payment endpoint not found yet. Card form is loading correctly; wire /api/payments/one-time/confirm to complete payment.'
        );
      } else {
        handleError(e2);
      }
    } finally {
      setLoading(false);
    }
  };
  const price = ticketAmountCents ? ticketAmountCents / 100 : 0;
  const discount = 0; // update later when promo is applied server-side
  const total = Math.max(0, price - discount);

  return (
    <Container>
      <Row>
        <Col md={12} className="d-flex flex-direction-row justify-content-center align-items-center m-3">
          <h3>Event Ticket Checkout</h3>
        </Col>
      </Row>

      {errorMessage && (
        <Row>
          <Col>
            <Alert variant="danger" dismissible onClose={() => setErrorMessage('')}>
              {errorMessage}
            </Alert>
          </Col>
        </Row>
      )}

      <Row className="d-flex flex-direction-row justify-content-center">
        <Col md={6} xs={12} className="m-3 d-flex flex-direction-column justify-content-center order-2 order-md-1">
          <Form onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Col md={12}>
                <Form.Group controlId="promo" className="mb-3">
                  <Form.Label className="stripe-like-label">Promo Code (Optional)</Form.Label>
                  <Form.Control
                    className="stripe-like-input"
                    type="text"
                    placeholder="PROMO10"
                    value={promoCode}
                    onChange={(e) => setPromoCode(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={12}>
                <PaymentElement />
              </Col>
              <Col>
                <Row className="mt-2">
                  <Button
                    variant="primary"
                    type="submit"
                    disabled={!stripe || loading || !ticketId}
                  >
                    {loading
                      ? 'Processing…'
                      : ticketAmountCents
                      ? `Pay $${(ticketAmountCents / 100).toFixed(2)}`
                      : 'Pay now'}
                  </Button>
                </Row>
              </Col>
            </Row>
          </Form>
        </Col>

                {/* Right: your flat-style price card */}
        <Col md={4} xs={12} className="order-1">

        <Row> <FlatStyledCard
            membershipPrice={price}
            discount={discount}
            total={total}
            title={`${ticketLabel} (One-time)`}
            totalLabel="Total (one-time)"
          /></Row>
          <Row>
          <Card className="flat-card">
            <Card.Body>
              <div className="membership-section">
                <ul>
                  <li>Meet the host Influencer in Person!</li>
                  <li>Group chat with Influencer Before Event</li>
                  <li>Catered food and drink(if listed)</li>
                  <li>Full refund if host no-shows (with support)</li>
                  <li>Raffle Ticket Announced in Chat</li>
                  <li>Ability to Review Influencer After Event</li>
                </ul>
              </div>
            </Card.Body>
          </Card>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default SingleCheckoutForm;
